import { TextArea } from '@material/mwc-textarea';
import { TextField } from '@material/mwc-textfield';
import { css } from 'lit';
import { customElement } from 'lit/decorators';

@customElement('proxi-textarea')
export class ProxiTextArea extends TextArea {

    static get styles() {
        return [
            ...TextField.styles,
            css`
                :host {
                    width: 100%;
                    --mdc-typography-subtitle1-font-size: 12px;
                    margin: 5px 0;
                }

                .mdc-text-field--textarea .mdc-text-field__input {
                    line-height: 1rem;
                }

                .mdc-text-field--textarea.mdc-text-field--outlined .mdc-text-field__input {
                    padding: 0.5rem;
                    margin: 0;
                }

                .mdc-text-field {
                    width: 100%;
                }

                .mdc-text-field-helper-line {
                    height: 0;
                }

                .mdc-floating-label {
                    transform: translateY(-50%) scale(0.75); /* Adjust the label position */
                }

                .mdc-text-field--outlined .mdc-floating-label {
                    transform: translateY(-1.5rem) scale(0.75); /* Adjust the label position for outlined variant */
                    background: white;
                }

                .mdc-text-field--outlined .mdc-floating-label--float-above {
                    transform: translateY(-1.5rem) scale(0.75); /* Adjust the label position when floating for outlined variant */
                    background: white;
                }

                .mdc-notched-outline__notch {
                    padding: 0;
                }

                /* Char counter inside */
                .mdc-text-field-character-counter {
                    font-size: 0.6rem;
                    position: relative;
                    right: 0;
                    margin-top: -20px;
                    margin-right: -10px;
                }

                .mdc-text-field + .mdc-text-field-helper-line {
                    padding-left: 0;
                }
            `
        ];
    }
}